import React from "react";
import PropTypes from "prop-types";
import plusIcon from "../../../assets/img/plus.svg";

/**
 * ConditionToggleButtons - Toggle buttons to show/hide condition sections
 * Contains buttons for Stay Dates, Booking Window, Blackout Dates, Length of Stay, Lead Time
 */
function ConditionToggleButtons({
  showPSD = false,
  showBooking = false,
  showBlackouts = false,
  showLOS = false,
  showLT = false,
  onTogglePSD,
  onToggleBooking,
  onToggleBlackouts,
  onToggleLOS,
  onToggleLT,
}) {
  return (
    <div className="condition-buttons-section">
      {!showPSD && (
        <button
          type="button"
          className="condition-button"
          onClick={onTogglePSD}
        >
          <img src={plusIcon} alt="Plus" className="plus-icon" />
          <span>Stay Dates</span>
        </button>
      )}
      {!showBooking && (
        <button
          type="button"
          className="condition-button"
          onClick={onToggleBooking}
        >
          <img src={plusIcon} alt="Plus" className="plus-icon" />
          <span>Booking Window</span>
        </button>
      )}
      {!showBlackouts && (
        <button
          type="button"
          className="condition-button"
          onClick={onToggleBlackouts}
        >
          <img src={plusIcon} alt="Plus" className="plus-icon" />
          <span>Blackout Dates</span>
        </button>
      )}
      {!showLOS && (
        <button
          type="button"
          className="condition-button"
          onClick={onToggleLOS}
        >
          <img src={plusIcon} alt="Plus" className="plus-icon" />
          <span>Length of Stay</span>
        </button>
      )}
      {!showLT && (
        <button type="button" className="condition-button" onClick={onToggleLT}>
          <img src={plusIcon} alt="Plus" className="plus-icon" />
          <span>Lead Time</span>
        </button>
      )}
    </div>
  );
}

ConditionToggleButtons.propTypes = {
  showPSD: PropTypes.bool,
  showBooking: PropTypes.bool,
  showBlackouts: PropTypes.bool,
  showLOS: PropTypes.bool,
  showLT: PropTypes.bool,
  onTogglePSD: PropTypes.func.isRequired,
  onToggleBooking: PropTypes.func.isRequired,
  onToggleBlackouts: PropTypes.func.isRequired,
  onToggleLOS: PropTypes.func.isRequired,
  onToggleLT: PropTypes.func.isRequired,
};

export default ConditionToggleButtons;
